import { createAction } from '@reduxjs/toolkit'

export const setFiltered = createAction('filtered/setFiltered')
export const setAll = createAction('filtered/setAll')
export const setCriteria = createAction('filtered/setCriteria')
export const clearCriteria = createAction('filtered/clearCriteria')
export const setOnOff = createAction('filtered/setOnOff')

